<template>
    <div class="link-manager">
        <div class="header"><a-button @click="showAdd" type="primary">添加鏈接</a-button></div>
        <a-table
                :dataSource="list"
                :loading="loading"
                :pagination="false">
            <a-table-column
                    title="鏈接名稱"
                    dataIndex="title"
                    align="center">
            </a-table-column>
            <a-table-column
                    title="鏈接logo"
                    align="center">
                <template slot-scope="item,row,index">
                    <img v-if="row.picPath!==''" style="max-width:100px;" :src="row.picPath" alt="">
                    <span v-else>無</span>
                </template>
            </a-table-column>
            <a-table-column
                    align="center"
                    title="鏈接地址"
                    dataIndex="linkPath">

            </a-table-column>
            <a-table-column
                    align="center"
                    title="上傳時間">
                <template slot-scope="item,row,index">
                    {{row.addTime | trans-date}}
                </template>
            </a-table-column>
            <a-table-column
                    align="center"
                    title="操作">
                <template slot-scope="sub,row,index">
                    <a-button @click="del(row)" style="margin-right:10px;" size="small">刪除</a-button>
                    <a-button @click="edit(row)" size="small">編輯</a-button>
                </template>
            </a-table-column>
        </a-table>
        <a-pagination v-model="currentPage" :total="total" @change="currentChange" />
        <a-modal
                :title="title"
                :visible="showEdit"
                @ok="action"
                :confirmLoading="confirmLoading"
                @cancel="hideEdit"
        >
            <a-form>
                <a-form-item label="鏈接名稱" required :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                    <a-input v-model="name" placeholder="請輸入鏈接名稱"/>
                </a-form-item>
                <a-form-item label="鏈接LOGO" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                    <a-upload
                            name="avatar"
                            listType="picture-card"
                            class="avatar-uploader"
                            :showUploadList="false"
                            :customRequest="upPic"
                            action=""
                    >
                        <img style="max-width:200px;" v-if="imageUrl" :src="imageUrl" alt="avatar" />
                        <div v-else>
                            <a-icon :type="loading ? 'loading' : 'plus'" />
                            <div class="ant-upload-text">上傳</div>
                        </div>
                    </a-upload>
                </a-form-item>
                <a-form-item label="鏈接地址" required :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                    <a-input v-model="link" placeholder="請輸入鏈接地址"/>
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                title:'',
                confirmLoading:false,
                showEdit:false,
                name:'',
                imageUrl:'',
                loading:false,
                link:'',
                list:[],
                para:{
                    pageIndex:1,
                    pageSize:10
                },
                currentPage:1,
                total:0,
                editor:false,
                editorId:''
            }
        },
        methods: {
            upPic(file){
                let self=this;
                this.loading=true;
                let param = new FormData()
                param.append('files', file.file)
                let config = {
                    headers: {'Content-Type': 'multipart/form-data'}
                };
                this.$http.post('/manager/media/upload/pic',param,config)
                    .then(response => {
                        self.imageUrl=response.data.mediaInfo[0].path;
                        self.picId=response.data.mediaInfo[0].id;
                        self.loading=false;
                    })
            },
            del(item){
                let self=this;
                this.$Confirm({
                    title:'確定刪除嗎？',
                    onOk(){
                        self.$http({
                            method: 'post',
                            url: '/manager/link/delete',
                            data:{
                                id:item.id
                            }
                        }).then(function(res){
                            self.$Message.success('操作成功')
                            self.getList()
                        }).catch(err=>{
                        })
                    },
                    onCancel(){
                    }
                })
            },
            currentChange(val){
                this.para.pageIndex=val;
                this.getList();
            },
            getList(){
                let self=this;
                self.$http({
                    method: 'post',
                    url: '/manager/link/list',
                    data:self.para
                }).then(function(res){
                    self.list=res.data.list;
                    self.currentPage=res.data.pageIndex;
                    self.total=res.data.totalRows;
                }).catch(err=>{
                })
            },
            edit(item){
                this.title='編輯鏈接'
                this.editor=true;
                this.name=item.title;
                this.link=item.linkPath;
                this.editorId=item.id;
                if(item.picPath!==''){
                    this.imageUrl=item.picPath;
                    this.picId=item.picId;
                }
                this.showEdit=true;
            },
            action(){
                let url;
                let self=this;
                let reg=/(http|ftp|https):\/\/([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?/
                if(this.name===''){
                    this.$Message.warning('鏈接名稱不能為空')
                    return false;
                }
                if(this.link===''){
                    this.$Message.warning('鏈接不能為空')
                    return false;
                }
                if(!reg.test(this.link)){
                    this.$Message.warning('鏈接非法')
                    return false;
                }
                let para={
                    linkPath:this.link,
                    title:this.name
                }
                if(this.picId!==''){
                    para.picId=this.picId;
                }
                if(this.editor){
                    para.id=this.editorId;
                    url='/manager/link/update'
                }else{
                    url='/manager/link/add'
                }
                this.confirmLoading=true;
                self.$http({
                    method: 'post',
                    url: url,
                    data:para
                }).then(function(res){
                    self.$Message.success('添加成功');
                    self.hideEdit()
                    self.confirmLoading=false;
                    self.para.pageIndex=1;
                    self.getList();
                }).catch(err=>{
                })
            },
            showAdd(){
                this.title='添加鏈接'
                this.showEdit=true;
            },
            hideEdit(){
                this.showEdit=false;
                this.title='';
                this.name=''
                this.link=''
                this.picId=''
                this.imageUrl=''
                this.editor=false;
            }
        },
        created() {
            this.getList();
            this.$emit('breadcrumbChange',['友情链接管理','友情链接管理'])
        },
    }
</script>
<style lang="less">
    div.link-manager{
        div.header{
            margin-bottom:20px;
            text-align: left;
        }

    }
</style>